/**
 * `en-US` I18n data for the shared translations.
 *
 * @access protected
 * @memberof Opal.I18n.app_base
 * @namespace Opal.I18n.app_base.shared~en-US
 */
_.defaults(Opal.I18n['en-US'].translation.app_base, {
  shared: {
    contact_support: 'Contact Opal support',
  },
})
